const niceMoney = (value) => {
    const num = Number(value);
    return Number.isFinite(num)
      ? new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 0,
        }).format(num)
      : value;
  };

  const niceASP = (value) => {
    const num = Number(value);
    return Number.isFinite(num)
      ? new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(num)
      : value;
  };

  function nicePercent(value) {
  return typeof value === "number" ? `${(value * 100).toFixed(2)}%` : value;
}

  const formatNumber = (value) => {
    const num = Number(value);
    return Number.isFinite(num) ? num.toLocaleString("en-US") : value;
  };

  export { niceMoney, niceASP, nicePercent, formatNumber };